<div class="tw:float-right">
  <div class="tw:flex tw:flex-row tw:gap-1">
    <ng-content />
    @if (registryService.tabForm()) {
      @if (registryService.isEditable()) {
        <div class="tw:flex tw:w-full tw:flex-wrap tw:justify-end">
          <div class="tw:flex tw:flex-row tw:gap-2">
            @if (id()) {
              <p-button
                [buttonProps]="{ autofocus: false }"
                test-id="cancel-button"
                icon="pi pi-undo"
                label="Cancel"
                severity="danger"
                variant="outlined"
                (click)="onCancelClick()" />
              @if (item().actions?.Write) {
                <p-buttongroup>
                  <p-button
                    [buttonProps]="{ autofocus: false }"
                    icon="pi pi-save"
                    test-id="save-button"
                    [label]="isSaveButtonBusy() ? 'Saving...' : 'Save Changes'"
                    [loading]="isSaveButtonBusy()"
                    [disabled]="isSaveButtonBusy()"
                    severity="primary"
                    (click)="onPreSave(SAVE_TYPES.WITHOUT_COMMENT)" />
                  <p-button
                    [buttonProps]="{ autofocus: false }"
                    [disabled]="isSaveButtonBusy()"
                    severity="primary"
                    icon="pi pi-chevron-down"
                    test-id="save-options-button"
                    (click)="saveOptionsPopover.toggle($event)" />
                </p-buttongroup>
                <p-popover #saveOptionsPopover>
                  <p-button
                    [buttonProps]="{ autofocus: false }"
                    (click)="onPreSave(SAVE_TYPES.WITH_COMMENT); saveOptionsPopover.hide()"
                    variant="text"
                    severity="contrast"
                    fluid
                    test-id="save-with-comment-button"
                    label="Save with comment"
                    styleClass="tw:justify-start" />
                </p-popover>
              }
            } @else {
              @if (buttonPermissions.writeActionPermission()) {
                <p-button
                  [buttonProps]="{ autofocus: false }"
                  icon="pi pi-save"
                  test-id="create-button"
                  label="Create"
                  [loading]="isSaveButtonBusy()"
                  [disabled]="isSaveButtonBusy()"
                  severity="primary"
                  (click)="onPreSave(SAVE_TYPES.WITHOUT_COMMENT)" />
              }
            }
          </div>
        </div>
      }
      <cor-edit-change-log
        [(visible)]="attemptSave"
        (confirmEvent)="onSaveConfirmation($event)" />
    }
    <!-- Edit  -->
    @if (id()) {
      <div class="tw:flex tw:flex-row tw:gap-1 tw:me-1 tw:whitespace-nowrap">
        <!-- Edit Button -->
        @if (
          buttonPermissions.showEditButton() &&
          !registryService.isEditable() &&
          registryService.tabForm()
        ) {
          <p-button
            test-id="object-edit-button"
            [buttonProps]="{ autofocus: false }"
            icon="pi pi-pen-to-square"
            label="Edit"
            severity="primary"
            (click)="editClick()" />
        }
        @if (item().actions?.Write) {
          <!-- Restore -->
          @if (buttonPermissions.isSnapshot()) {
            <p-button
              test-id="action-btns-restore"
              [buttonProps]="{ autofocus: false }"
              icon="pi pi-replay"
              label="Restore"
              severity="secondary"
              variant="outlined"
              (click)="restoreSnapshot()" />
          }
        }
        @if (!registryService.isEditable()) {
          @if (!buttonPermissions.isSnapshot()) {
            <!-- Execution Option -->
            @if (buttonPermissions.isSimulatable()) {
              <cor-execution-options
                [id]="id()"
                [item]="item()"
                [object]="object()" />
            }
          }

          <!-- item.actions?.Read checks if user has read access of that object -->
          <!-- buttonPermissions.writeActionPermission() checks if we have permission to write in that module -->
          @if (item().actions?.Read && buttonPermissions.writeActionPermission()) {
            @if (!buttonPermissions.isSnapshot()) {
              <!-- To allow copy/clone - user should be able to READ from source, and WRITE to destination -->
              <!-- Copy -->
              @if (buttonPermissions.isCopyable()) {
                <p-splitbutton
                  test-id="object-copy-button"
                  icon="pi pi-copy"
                  [label]="copy.isSaving() ? 'Copying...' : 'Copy'"
                  [model]="copyMenuItems()"
                  [disabled]="copy.isSaving()"
                  severity="secondary"
                  outlined
                  appendTo="body"
                  (onClick)="copyItem()" />
              }

              <!-- Clone -->
              @if (buttonPermissions.isCloneable()) {
                <p-button
                  test-id="object-clone-button"
                  [buttonProps]="{ autofocus: false }"
                  icon="pi pi-clone"
                  label="Clone"
                  [loading]="clone.isSaving()"
                  [disabled]="clone.isSaving()"
                  severity="secondary"
                  variant="outlined"
                  (click)="cloneItem()" />
              }
            }

            <!-- Restore as Copy -->
            @if (buttonPermissions.isSnapshot() && buttonPermissions.isCopyable()) {
              <p-button
                test-id="action-btns-copy"
                [buttonProps]="{ autofocus: false }"
                icon="pi pi-copy"
                label="Copy"
                severity="secondary"
                variant="outlined"
                pTooltip="Copy this snapshot of the object."
                (click)="restoreSnapshotAsCopy()" />
            }

            @if (buttonPermissions.isSnapshot()) {
              <p-button
                test-id="action-btns-view-latest"
                [buttonProps]="{ autofocus: false }"
                icon="pi pi-link"
                label="View Latest"
                pTooltip="You are viewing an older snapshot in the history of this object. Click to view the latest version."
                variant="outlined"
                [routerLink]="latestVersionLink()" />
            }
          }

          @if (buttonPermissions.showRequestAccessButton()) {
            <cor-project-access-request-dialog
              title="Request Write Access"
              variant="outlined" />
          }
        }

        @if (!buttonPermissions.isSnapshot()) {
          @if (hasExtraOptions()) {
            <p-button
              #actionExtraOptions
              [buttonProps]="{ autofocus: false }"
              test-id="object-more-button"
              (click)="actionExtraOptionsPopover.toggle($event)"
              rounded
              severity="secondary"
              icon="pi pi-ellipsis-v" />
          }

          <p-popover #actionExtraOptionsPopover>
            <div class="tw:flex tw:flex-col">
              <!-- Start: Download options -->
              @if (buttonPermissions.isExportable()) {
                <cor-download-options
                  [id]="id()"
                  [item]="item()"
                  [object]="object()"
                  [service]="service()" />
              }
              <!-- End: Download options -->

              @if (buttonPermissions.showArchiveButton()) {
                <p-button
                  (click)="archiveItem(); actionExtraOptionsPopover.hide()"
                  [buttonProps]="{ autofocus: false }"
                  [style]="{ 'justify-content': 'start' }"
                  fluid
                  severity="contrast"
                  variant="text"
                  icon="pi pi-inbox"
                  [loading]="archive.isArchiving()"
                  test-id="object-archive-button"
                  label="Archive" />
              }

              @if (buttonPermissions.showUnarchiveButton()) {
                <p-button
                  (click)="unarchiveItem(); actionExtraOptionsPopover.hide()"
                  [buttonProps]="{ autofocus: false }"
                  [style]="{ 'justify-content': 'start' }"
                  fluid
                  severity="contrast"
                  variant="text"
                  icon="pi pi-replay"
                  [loading]="archive.isUnarchiving()"
                  test-id="object-unarchive-button"
                  label="Unarchive" />
              }

              @if (buttonPermissions.showMoveProjectButton()) {
                <p-button
                  (click)="moveProject.visible.set(true); actionExtraOptionsPopover.hide()"
                  [buttonProps]="{ autofocus: false }"
                  [style]="{ 'justify-content': 'start' }"
                  fluid
                  severity="contrast"
                  variant="text"
                  icon="pi pi-box"
                  test-id="object-move-button"
                  label="Move to Another Project" />
              }

              <ng-container *ngTemplateOutlet="extraOptions()" />

              <!-- Start: Delete object button -->
              @if (buttonPermissions.showDeleteButton()) {
                <div class="tw:border-t tw:border-surface tw:h-[0.1em]"></div>
                <cor-delete-object
                  [item]="item()"
                  [object]="object()"
                  [service]="service()"
                  [isWorkflowable]="buttonPermissions.isWorkflowable()"
                  [versionList]="versionList()" />
              }
              <!-- End: Delete object button -->
            </div>
          </p-popover>
        }
      </div>
    }
  </div>
</div>

<p-dialog
  [(visible)]="showNoAccessDialog"
  [modal]="true"
  header="Restricted Access!"
  styleClass="tw:w-[30rem]">
  <div class="tw:flex tw:flex-col tw:gap-3">You're not authorized to edit this object.</div>

  <ng-template pTemplate="footer">
    <div class="tw:flex tw:flex-auto tw:justify-end tw:gap-2 tw:my-2">
      @if (buttonPermissions.writeActionPermission() && buttonPermissions.isCopyable()) {
        <p-button
          test-id="action-btns-copy-2"
          [buttonProps]="{ autofocus: false }"
          icon="pi pi-copy"
          label="Copy"
          [loading]="copy.isSaving()"
          [disabled]="copy.isSaving()"
          severity="primary"
          variant="outlined"
          (click)="copyItem()" />
      }
    </div>
  </ng-template>
</p-dialog>

@if (moveProject.visible && item()?.id) {
  <cor-move-project
    [(visible)]="moveProject.visible"
    [(isCopying)]="moveProject.isCopying"
    [item]="item()"
    [object]="object()"
    (moved)="moveProject.onMove($event)"
    (copied)="moveProject.onCopy($event)" />
}
